import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Dropdown, Button } from "react-bootstrap";
import closeIcon from "../../../src/common/assets/images/close-icon.png";
import "./EpisodeStatus.css";
import { FaEllipsisH, FaCog } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { BiBarChartSquare, BiLoader, BiMoney } from "react-icons/bi";
import magicIcon from "../../common/assets/images/magicIcon.png";
import starsIcon from "../../common/assets/images/starsImg.png";
import drg1Icon from "../../assets/notification-text.png";
import drg2Icon from "../../assets/calendar-check-02.png";
import drg3Icon from "../../assets/pie-chart-04.png";
import drg4Icon from "../../assets/star-01.png";
import Pagination from "react-bootstrap/Pagination";
import { CodeContext } from "../pages/Coder/Coder";
import { useLazyGetData2Query } from "../../store/apiSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Drawer,
  Divider,
  Grid,
  Modal,
  Card,
  CardActionArea,
  CardContent,
  OutlinedInput,
  InputLabel,
  FormControl,
  Select 
} from "@mui/material";
import {
  getDocumentViewerData,
  resetEpisodeIdentifierTopassDocumentViewer,
  setDocumentviewerPage,
  setEpisodeIdentifierTopassDocumentViewer,
} from "../DocumentViewer/redux/DocumentViewerSlicer";
// import Select from "react-select";
import { getHealthInsuranceManagerFilterOptions } from "../../components/Codeworkflow/HealthInsuranceManager/redux/HealthInsuranceManagerSlicer";
import {
  changeStatus,
  getAuditorViewData,
  updateAuditorPage,
} from "../Codeworkflow/AuditorView/redux/AuditorViewSlicer";
import { Spinner } from "../../utils/Spinner";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
} from "../pages/EpisodeList/redux/EpisodeListSlicer";
import { Loader } from "../../utils/Loader";
import Skeleton from "react-loading-skeleton";
import LdsRoller from "../../utils/LdsRoller";
import DotsLoader from "../../utils/DotsLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { viewEmrDmrPas } from "../CodingScreen/Service";
import confirm_tick from "../../common/assets/images/confirm.png";
import {
  fetchEpisodes,
  getAuditResponse,
} from "../pages/Coder/redux/CoderSlicer";
import { fetchCodersData } from "../Codeworkflow/CoderView/redux/CoderScreenSlice";
import { getResponsiveSliceConfig } from "./utils/ResponsiveSliceConfig";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
// import { setDocumentviewerPage } from "../../components/DocumentViewer/redux/DocumentViewerSlicer"
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}

const EpisodeStatus = ({
  drgData,
  setDrgData,
  allEpisodesListData,
  episodesFilterList,
  isEpisodesLoading,
  waitTillLoad,
  setSkipAcceptApi,
  codingscreendata,
  pasHyperLink,
  setPasHyperLink,
  handleDRGOptions,
  handleDrgInformation,
  handleConfirmDrg,
  isDrgConfirmed,
  acceptedCodes,
  handleEpisodeChange,
  currentEpisode,
  setCurrentEpisode,
  currentStatus,
  setCurrentStatus,
  currentEpisodeNumber,
  setCurrentEpisodeNumber,
  drgConfirmedStatusUpdate,
  setOpenStatusUpdatedModal,
}) => {
  // console.log(codingscreendata, "epstcd");
  const width = useWindowWidth();
  const SLICE_CONFIG = getResponsiveSliceConfig(width);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { episodeList } = useSelector((state) => state);

  const handleOpen = (event) => {
    setMobileOpen(true);
  };

  const dispatch = useDispatch();
  const newEpisodeListFilterObj = JSON.parse(localStorage.getItem("filters"));
  const [triggerGetData2, { data, error, isLoading }] = useLazyGetData2Query();
  const codersData = useSelector((state) => state.coderscreenqueue.codersData);
  const { auditorViewData, auditorViewDataLoading, auditorViewDataError } =
    useSelector((state) => state.auditorView.auditorViewResponse);
  // const {
  //   episodesFilterList,
  //   episodesFilterListLoading,
  //   episodesFilterListError,
  // } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const [totalEpisodes, setTotalEpisodes] = useState([]);

  const currentScreen = localStorage.getItem("currentPage");
  const last_hcp_line_id = localStorage.getItem("last_hcp_line_id");
  const last_epi_identifier = localStorage.getItem("last_epi_identifier");
  const [selectedVersion, setSelectedVersion] = useState(null);
  const handleSelect = (item)=>{
    setSelectedVersion(item);
    // Optional: close after selecting
   
  }
  // 🔁 When drgData changes (after API loads), set default version
  useEffect(() => {
    if (drgData?.grouper_versions?.length > 0) {
      setSelectedVersion(drgData.grouper_versions[0]);
    }
  }, [drgData]);

  // 🧩 Safely find the selected DRG data
  const selectedDrgData = drgData?.drgs?.find(
    (obj) => obj[selectedVersion] !== undefined
  )?.[selectedVersion];
    const handleChange = (event) => {
    setSelectedVersion(event.target.value);
  };
  //   const staticData = [
  //      {
  //     code: "U60Z",
  //     details:[
  //     {
  //       label: "MS-DRG",
  //       drgValue: 885,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Other Circulatory System Diagnoses with MCC (Major Complications or Comorbidities)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue: 0.9524,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,974"
  //     },
  //   ],
  // },
  // {
  //   code: "960Z",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 981,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Gastrointestinal Stromal Tumor (GIST) with Stomach and/or Small Intestine Excision",
  //       MDCLabel: "MCD",
  //       MDCValue: "06 – Diseases & Disorders of the Digestive System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  9.0,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$56,457"
  //      }
  //   ]
  // },
  // {
  //   code: "G48B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 603,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Cellulitis with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.6521,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$10,346"
  //      }
  //   ]
  // },
  // {
  //   code: "G48A",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 603,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Cellulitis with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.6521,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$10,346"
  //      }
  //   ]
  // },
  // {
  //   code: "Q60B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 820,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Lymphoma and Leukemia with Major Operating Room Procedures with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  4.2122,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$26,423"
  //      }
  //   ]
  // },
  // {
  //   code: "I04A",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 280,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Acute Myocardial Infarction, Discharged Alive with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.2226,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$7,669"
  //      }
  //   ]
  // },
  // {
  //   code: "I04B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 280,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Acute Myocardial Infarction, Discharged Alive with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.2226,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$7,669"
  //      }
  //   ]
  // },
  // {
  //   code: "G64Z",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 394,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Other Circulatory System Diagnoses with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  0.9369,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,877"
  //      }
  //   ]
  // },
  // {
  //   code: "K60B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 637,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Diabetes with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "10 – Endocrine, Nutritional & Metabolic Diseases & Disorders",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  0.8537,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,355"
  //      }
  //   ]
  // }
  //   ]

  useEffect(() => {
    if (currentScreen === "episodeList") {
      setTotalEpisodes(episodesFilterList?.episode || []);
    } else if (currentScreen === "coderview") {
      setTotalEpisodes(codersData?.episodes || []);
    } else if (currentScreen === "auditorPage") {
      setTotalEpisodes(auditorViewData?.episodes || []);
    }
  }, [currentScreen, episodesFilterList?.episode, codersData, auditorViewData]);
  // const filtered_line_id = totalEpisodes?.map((item) => item?.hcp_line_id);
  // const min_hcp_line_id = Math?.min(...filtered_line_id);
  // const max_hcp_line_id = Math?.max(...filtered_line_id);
  const filtered_line_id = Array?.isArray(totalEpisodes)
    ? totalEpisodes
        ?.map((item) => Number(item?.hcp_line_id))
        ?.filter((id) => !isNaN(id))
    : [];

  const min_hcp_line_id =
    filtered_line_id?.length > 0 ? Math.min(...filtered_line_id) : null;

  const max_hcp_line_id =
    filtered_line_id?.length > 0 ? Math?.max(...filtered_line_id) : null;

  const drgLabels = {
    "960Z": "Ungroupable",
    "961Z": "Unacceptable Principal Diagnosis",
    "963Z": "Neonatal Diagnosis Not Consistent W Age/Weight",
  };
  const checkModalStatus = JSON.parse(
    localStorage.getItem("episode-status-modal")
  );
  const { drgValue, weightValue, reimbursementValue } = useContext(CodeContext);
  const { drgloading } = useContext(CodeContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [showTooltipHover, setShowTooltipHover] = useState("");
  const [auditStatusChangeModal, setAuditStatusChangeModal] = useState(false);
  // const [episodeStatusChangeModal, setEpisodeStatusChangeModal] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const allDrgInformation = useSelector(
    (state) => state?.coder?.drgInformation
  );
  const allDrgInfoLoading = useSelector(
    (state) => state.coder.loadingDrgInformation
  );
  const {
    healthInsuranceManagerFiltersPriority,
    healthInsuranceManagerFiltersStatus,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerFilters
  );

  const { statusChangeLoading, statusChangeMessage, statusChangeError } =
    useSelector((state) => state.auditorView.status);

  const coderOptions = [
    // {label: "Coding Complete", value: "Coding Complete"},
    { label: "On Hold", value: "On Hold" },
    { label: "Send to audit", value: "Send to audit" },
    { label: "Outstanding", value: "Outstanding" },
  ];

  const auditorOptions = [
    { label: "Audited", value: "Audited" },
    // { label: "Audit - Awaiting Audit", value: "Audit - Awaiting Audit" },
    { label: "Audit - Pending CDQ", value: "Audit - Pending CDQ" },
    { label: "Audit - On Hold", value: "Audit - On Hold" },
    { label: "Audit in Progress", value: "Audit in Progress" },
  ];

  const { auditorPage } = useSelector((state) => state.auditorView);
  const {
    auditStatusStatusLoading,
    auditStatusStateData,
    auditStatusStateError,
  } = useSelector((state) => state.coder.auditStatusState);
  useEffect(() => {
    if (lastCodedEpisode?.selectedEpisode !== undefined) {
      setCurrentEpisode(lastCodedEpisode?.selectedEpisode);
      setCurrentStatus(lastCodedEpisode?.selectedEpisode?.status);
    }
    if (
      lastCodedEpisode?.selectedEpisode?.hcp_line_id !== undefined ||
      lastCodedEpisode?.selectedEpisode?.hcp_line_id !== NaN
    ) {
      setCurrentEpisodeNumber(lastCodedEpisode?.selectedEpisode?.hcp_line_id);
    }
  }, [lastCodedEpisode?.selectedEpisode]);

  const calculateAge = (dob, admissionDate) => {
    if (!dob || !admissionDate) {
      return 0;
    }

    let birthDate, admitDate;

    const dobParts = dob.split("-").map(Number);
    birthDate =
      dobParts[0] > 31
        ? new Date(dobParts[0], dobParts[1] - 1, dobParts[2])
        : new Date(dobParts[2], dobParts[1] - 1, dobParts[0]);

    const admitParts = admissionDate.split("-").map(Number);
    admitDate =
      admitParts[0] > 31
        ? new Date(admitParts[0], admitParts[1] - 1, admitParts[2])
        : new Date(admitParts[2], admitParts[1] - 1, admitParts[0]);

    let age = admitDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = admitDate.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && admitDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return isNaN(age) ? 0 : age;
  };

  const age = calculateAge(
    currentEpisode?.date_of_birth,
    currentEpisode?.admission_date
  );

  function getEpisodeData(currentEpisode, age, useLabelFallback = false) {
    function displayValue(value, label) {
      if (value === null || value === undefined || value === "") {
        return useLabelFallback ? `No ${label.toLowerCase()}` : "-";
      }
      return value;
    }

    return [
      {
        label: "MRN",
        value: displayValue(currentEpisode?.medical_record_number, "MRN"),
      },
      {
        label: "Episode ID",
        value: displayValue(currentEpisode?.episode_identifier, "Episode ID"),
      },
      {
        label: "Admission Date",
        value: displayValue(currentEpisode?.admission_date, "Admission Date"),
      },
      {
        label: "Discharge Date",
        value: displayValue(currentEpisode?.separation_date, "Discharge Date"),
      },
      { label: "Age", value: displayValue(age, "Age") },
      { label: "Sex", value: displayValue(currentEpisode?.sex, "Sex") },
      {
        label: "Length of stay",
        value: currentEpisode?.length_of_stay ?? 0,
      },
      {
        label: "Specialty",
        value: displayValue(currentEpisode?.speciality, "Specialty"),
      },
      {
        label: "Status",
        value: displayValue(currentEpisode?.status, "Status"),
      },
    ];
  }

  const episodeDataWithDash = getEpisodeData(currentEpisode, age, false);
  const episodeDataWithLabel = getEpisodeData(currentEpisode, age, true);

  const episodeData = [
    { label: "MRN", value: currentEpisode?.medical_record_number || "-" },
    { label: "Episode ID", value: currentEpisode?.episode_identifier || "-" },
    { label: "Admission Date", value: currentEpisode?.admission_date || "-" },
    { label: "Discharge Date", value: currentEpisode?.separation_date || "-" },
    { label: "Age", value: age || "No age" },
    { label: "Sex", value: currentEpisode?.sex || "-" },
    {
      label: "Length of stay",
      value: currentEpisode?.length_of_stay
        ? currentEpisode?.length_of_stay
        : 0,
    },
    { label: "Specialty", value: currentEpisode?.speciality || "No specialty" },
    { label: "Status", value: currentEpisode?.status || "No status" },
  ];

  const allCodes = [
    ...(codingscreendata?.data?.procedure_codes || []),
    ...(codingscreendata?.data?.additional_diagnoses || []),
    ...(codingscreendata?.data?.principal_diagnosis || []),
  ];
  // console.log(allCodes,codingscreendata, "epstatuscodes");

  // Filter only AI-origin codes
  const aiCodes = allCodes.filter((code) => code.origin === "AI");
  const allOriginsAreU = allCodes.every(
    (item) =>
      item.origin === "U" ||
      item.origin === "AU" ||
      item.origin === "P" ||
      ((codingscreendata?.data?.meta?.status === "Coding Complete" ||
        codingscreendata?.data?.meta?.status === "Audited") &&
        item.origin === "AI")
  );
  const allCodesAccepted =
    aiCodes.length > 0 &&
    aiCodes.every((code) => !!(acceptedCodes?.[code.code.trim()] ?? false));
  const isButtonEnabled = allCodesAccepted;

  const changeRecord = (id, newData) => {
    let newEpisode =
      newData?.length > 0 && newData?.find((eId) => eId?.hcp_line_id === id);
    // console.log(newEpisode, 'newEpisode inside onchange function')
    // if (newEpisode?.episode_identifier?.length > 0) {
    //   dispatch(
    //     getDocumentViewerData({
    //       documentEpisodeIdentifier: newEpisode?.episode_identifier,
    //       documentCurrentPage: 1,
    //     })
    //   );
    // }
    setCurrentEpisode(newEpisode);
    dispatch(selectedEpisodeList(newEpisode));
    dispatch(
      setEpisodeIdentifierTopassDocumentViewer(newEpisode?.episode_identifier)
    );
  };

  // const handleDocumentPrev = () => {
  //   sessionStorage.setItem("trackHistory", JSON.stringify([]));
  //   sessionStorage.setItem("redoStack", JSON.stringify([]));
  //   handleEpisodeChange();
  //   setSkipAcceptApi(true);
  //   dispatch(setDocumentviewerPage(1));
  //   dispatch(resetEpisodeIdentifierTopassDocumentViewer());
  //   setCurrentEpisodeNumber((prev) => {
  //     // let allHcpData = [];
  //     // if(currentScreen === "episodeList"){
  //     // } else if (currentScreen === "coderview") {
  //     // allHcpData = codersData?.episodes?.map(item => item.hcp_line_id) || [];
  //     // } else if (currentScreen === "auditorPage") {
  //     // allHcpData = auditorViewData?.episodes?.map(item => item.hcp_line_id) || [];
  //     // }
  //     let allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
  //     // console.log("outside hcplineIDs prev-btn", allHcpData)

  //     const currentIndex = allHcpData?.indexOf(prev);
  //     const isFirstItem = currentIndex === 0;
  //     let hasPrevPage = newEpisodeListFilterObj?.page > 1;

  //     if (currentScreen === "episodeList") {
  //       hasPrevPage = newEpisodeListFilterObj.page > 1;
  //     } else if (currentScreen === "coderview") {
  //       hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
  //     } else if (currentScreen === "auditorPage") {
  //       hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
  //     }
  //     if (isFirstItem && hasPrevPage) {
  //       let updatedFilter;
  //       if (currentScreen === "episodeList") {
  //         updatedFilter = {
  //           ...newEpisodeListFilterObj,
  //           page: newEpisodeListFilterObj.page - 1,
  //         };
  //       } else if (currentScreen === "coderview") {
  //         updatedFilter = {
  //           ...newEpisodeListFilterObj,
  //           page_number: newEpisodeListFilterObj?.page_number - 1,
  //         };
  //       } else if (currentScreen === "auditorPage") {
  //         updatedFilter = {
  //           ...newEpisodeListFilterObj,
  //           page_number: newEpisodeListFilterObj?.page_number - 1,
  //         };
  //       }

  //       localStorage.setItem("filters", JSON.stringify(updatedFilter));

  //       // Dispatch API and handle the result outside the setState callback
  //       const fetchDataAndUpdate = async () => {
  //         let response;
  //         let newData = [];
  //         let updatedHcpLineIds = [];
  //         let lastId = "";
  //         switch (currentScreen) {
  //           case "episodeList":
  //             response = await dispatch(getFilterEpisodeLists(updatedFilter));
  //             newData = response?.payload?.episode || [];
  //             // console.log(newData?.episode, 'newData?.episode')
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               lastId = updatedHcpLineIds[updatedHcpLineIds.length - 1];
  //               changeRecord(lastId, newData);
  //               localStorage.setItem("last_hcp_line_id", lastId);
  //               triggerGetData2();
  //             }
  //             break;
  //           case "coderview":
  //             response = await dispatch(fetchCodersData(updatedFilter));
  //             newData = response?.payload?.episodes || [];
  //             changeRecord(lastId, newData);
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               lastId = updatedHcpLineIds[updatedHcpLineIds.length - 1];
  //               changeRecord(lastId, newData);
  //               localStorage.setItem("last_hcp_line_id", lastId);
  //               triggerGetData2();
  //             }
  //             break;
  //           case "auditorPage":
  //             response = await dispatch(getAuditorViewData(updatedFilter));
  //             newData = response?.payload?.episodes || [];
  //             changeRecord(lastId, newData);
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               lastId = updatedHcpLineIds[updatedHcpLineIds.length - 1];
  //               changeRecord(lastId, newData);
  //               localStorage.setItem("last_hcp_line_id", lastId);
  //               triggerGetData2();
  //             }
  //             break;
  //         }
  //         // console.log(updatedHcpLineIds, 'updatedHcpLineIds inside condition prev')
  //         // newData = response?.payload || [];
  //         // updatedHcpLineIds = newData?.episode?.map(item => item?.hcp_line_id);
  //         // if (updatedHcpLineIds?.length > 0) {
  //         //   // const lastId = updatedHcpLineIds[updatedHcpLineIds.length - 1];
  //         //   // changeRecord(lastId, newData);
  //         //   localStorage.setItem("last_hcp_line_id", lastId);
  //         //   triggerGetData2();
  //         //   // getCurrentEpisodeData(lastId);
  //         // }
  //       };

  //       fetchDataAndUpdate();

  //       return prev;
  //     }

  //     if (currentIndex <= 0) return prev;

  //     // const newHcpLineId = allHcpData[currentIndex - 1];
  //     // const response = dispatch(getFilterEpisodeLists(updatedFilter));
  //     // const newData = response?.payload?.episode || [];
  //     // changeRecord(newHcpLineId, newData);
  //     // localStorage.setItem("last_hcp_line_id", newHcpLineId);
  //     // triggerGetData2();
  //     // // getCurrentEpisodeData(newHcpLineId);
  //     // return newHcpLineId;
  //     const updatedFilter = JSON.parse(localStorage.getItem("filters"));

  //     dispatch(getFilterEpisodeLists(updatedFilter))
  //       .unwrap()
  //       .then((data) => {
  //         const newData = data?.episode || [];
  //         console.log("✅ New Episodes:", newData);

  //         if (newData?.length > 0) {
  //           const allHcpData =
  //             totalEpisodes?.map((item) => item?.hcp_line_id) || [];
  //           const currentIndex = allHcpData?.indexOf(prev);

  //           const newHcpLineId = allHcpData[currentIndex - 1];
  //           changeRecord(newHcpLineId, newData);
  //           localStorage.setItem("last_hcp_line_id", newHcpLineId);
  //           triggerGetData2();

  //           return newHcpLineId;
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("❌ Fetch failed:", err);
  //       });
  //   });
  // };

  // const handleDocumentNext = () => {
  //   sessionStorage.setItem("trackHistory", JSON.stringify([]));
  //   sessionStorage.setItem("redoStack", JSON.stringify([]));
  //   handleEpisodeChange();
  //   setSkipAcceptApi(true);
  //   dispatch(setDocumentviewerPage(1));
  //   dispatch(resetEpisodeIdentifierTopassDocumentViewer());
  //   setCurrentEpisodeNumber((prev) => {
  //     // let allHcpData = [];
  //     // if (currentScreen === "episodeList") {
  //     // } else if (currentScreen === "coderview") {
  //     // allHcpData = codersData?.episodes?.map(item => item.hcp_line_id) || [];
  //     // } else if (currentScreen === "auditorPage") {
  //     // allHcpData = auditorViewData?.episodes?.map(item => item.hcp_line_id) || [];
  //     // }
  //     let allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
  //     // console.log("outside hcplineIDs next-btn", allHcpData)

  //     const currentIndex = allHcpData?.indexOf(prev);
  //     const isLastItem = currentIndex === allHcpData?.length - 1;
  //     let hasNextPage = false;
  //     if (currentScreen === "episodeList") {
  //       hasNextPage =
  //         newEpisodeListFilterObj.page <
  //         Math.ceil(
  //           episodesFilterList?.total_episodes /
  //             newEpisodeListFilterObj.page_size
  //         );
  //     } else if (currentScreen === "coderview") {
  //       hasNextPage =
  //         newEpisodeListFilterObj?.page_number <
  //         Math.ceil(codersData?.episode_meta_data?.meta?.total_count / 10);
  //     } else if (currentScreen === "auditorPage") {
  //       hasNextPage =
  //         newEpisodeListFilterObj?.page_number <
  //         Math.ceil(auditorViewData?.episode_meta_data?.meta?.total_count / 10);
  //     }
  //     let updatedFilter = { ...newEpisodeListFilterObj };
  //     if (isLastItem && hasNextPage) {
  //     if (currentScreen === "episodeList") {
  //       updatedFilter.page += 1;
  //     } else {
  //       updatedFilter.page_number += 1;
  //     }
  //     localStorage.setItem("filters", JSON.stringify(updatedFilter));
  //   } else {
  //     // use same filter if not last
  //     updatedFilter = JSON.parse(localStorage.getItem("filters")) || updatedFilter;
  //   }

  //       // Dispatch API and handle the result outside the setState callback
  //       const fetchDataAndUpdate = async () => {
  //         let response;
  //         let newData = [];
  //         let updatedHcpLineIds = [];
  //         let firstId = "";
  //         switch (currentScreen) {
  //           case "episodeList":
  //             response = await dispatch(getFilterEpisodeLists(updatedFilter));
  //             newData = response?.payload?.episode || [];
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               firstId = updatedHcpLineIds[0];
  //               changeRecord(firstId, newData?.episode);
  //               localStorage.setItem("last_hcp_line_id", firstId);
  //               triggerGetData2();
  //             }
  //             break;
  //           case "coderview":
  //             response = await dispatch(fetchCodersData(updatedFilter));
  //             newData = response?.payload?.episodes || [];
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               firstId = updatedHcpLineIds[0];
  //               changeRecord(firstId, newData);
  //               localStorage.setItem("last_hcp_line_id", firstId);
  //               triggerGetData2();
  //             }
  //             break;
  //           case "auditorPage":
  //             response = await dispatch(getAuditorViewData(updatedFilter));
  //             newData = response?.payload?.episodes || [];
  //             setTotalEpisodes(newData);
  //             updatedHcpLineIds = newData?.map((item) => item?.hcp_line_id);
  //             if (updatedHcpLineIds?.length > 0) {
  //               firstId = updatedHcpLineIds[0];
  //               changeRecord(firstId, newData);
  //               localStorage.setItem("last_hcp_line_id", firstId);
  //               triggerGetData2();
  //             }
  //             break;
  //         }

  //         // console.log(updatedHcpLineIds, 'updatedHcpLineIds inside condition next')
  //         // const newData = response?.payload || [];
  //         // const updatedHcpLineIds = newData?.episode?.map(item => item?.hcp_line_id);
  //         // if (updatedHcpLineIds?.length > 0) {
  //         //   const firstId = updatedHcpLineIds[0];
  //         //   changeRecord(firstId);
  //         //   localStorage.setItem("last_hcp_line_id", firstId);
  //         //   triggerGetData2();
  //         //   // getCurrentEpisodeData(firstId);
  //         // }
  //       };

  //       fetchDataAndUpdate();
  //       return prev;
  //     }
  //     // if (newIndex === -1 || newIndex >= allHcpData.length - 1) return prev;

  //     const updatedFilter = JSON.parse(localStorage.getItem("filters"));

  //     dispatch(getFilterEpisodeLists(updatedFilter))
  //       .unwrap()
  //       .then((data) => {
  //         const newData = data?.episode || [];
  //         console.log("✅ New Episodes:", newData);

  //         if (newData?.length > 0) {
  //           const allHcpData =
  //             totalEpisodes?.map((item) => item?.hcp_line_id) || [];
  //           const currentIndex = allHcpData?.indexOf(prev);

  //           const newHcpLineId = allHcpData[currentIndex + 1];
  //           changeRecord(newHcpLineId, newData);
  //           localStorage.setItem("last_hcp_line_id", newHcpLineId);
  //           triggerGetData2();

  //           return newHcpLineId;
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("❌ Fetch failed:", err);
  //       });
  //   });
  // };

  // const getCurrentEpisodeData = (new_hcp_line_id) => {
  //   // const currentEpisodeIdentifier = codersData && codersData?.episodes?.find(
  //   //   (episode) => episode.hcp_line_id === new_hcp_line_id
  //   // );

  //   let currentEpisodeIdentifier = null;
  //     if(currentScreen === "episodeList"){
  //     currentEpisodeIdentifier = episodesFilterList?.episode?.find(
  //     (episode) => episode.hcp_line_id === new_hcp_line_id)
  //     } else if (currentScreen === "coderview"){
  //        currentEpisodeIdentifier = codersData && codersData?.episodes?.find(
  //     (episode) => episode.hcp_line_id === new_hcp_line_id
  //   );
  //     } else if (currentScreen === "auditorPage"){
  //        currentEpisodeIdentifier = codersData && codersData?.episodes?.find(
  //     (episode) => episode.hcp_line_id === new_hcp_line_id)
  //     }

  //     if(currentEpisodeIdentifier?.episode_identifier?.length > 0){
  //       dispatch(
  //         getDocumentViewerData({
  //           documentEpisodeIdentifier: currentEpisodeIdentifier?.episode_identifier,
  //           documentCurrentPage: 1,
  //         })
  //       );
  //     }
  //     dispatch(selectedEpisodeList(currentEpisodeIdentifier));
  // };


  const handleDocumentPrev = () => {
  sessionStorage.setItem("trackHistory", JSON.stringify([]));
  sessionStorage.setItem("redoStack", JSON.stringify([]));
  handleEpisodeChange();
  setSkipAcceptApi(true);
  dispatch(setDocumentviewerPage(1));
  dispatch(resetEpisodeIdentifierTopassDocumentViewer());

  setCurrentEpisodeNumber((prev) => {
    const allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
    const currentIndex = allHcpData?.indexOf(prev);
    const isFirstItem = currentIndex === 0;

    let hasPrevPage = false;
    if (currentScreen === "episodeList") {
      hasPrevPage = newEpisodeListFilterObj.page > 1;
    } else if (currentScreen === "coderview") {
      hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
    } else if (currentScreen === "auditorPage") {
      hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
    }

    let updatedFilter = { ...newEpisodeListFilterObj };
    if (isFirstItem && hasPrevPage) {
      if (currentScreen === "episodeList") {
        updatedFilter.page -= 1;
      } else {
        updatedFilter.page_number -= 1;
      }
      localStorage.setItem("filters", JSON.stringify(updatedFilter));
    } else {
      updatedFilter = JSON.parse(localStorage.getItem("filters")) || updatedFilter;
    }

    const fetchDataAndUpdate = async () => {
      try {
        let response;
        let newData = [];

        switch (currentScreen) {
          case "episodeList":
            response = await dispatch(getFilterEpisodeLists(updatedFilter)).unwrap();
            newData = response?.episode || [];
            break;

          case "coderview":
            response = await dispatch(fetchCodersData(updatedFilter)).unwrap();
            newData = response?.episodes || [];
            break;

          case "auditorPage":
            response = await dispatch(getAuditorViewData(updatedFilter)).unwrap();
            newData = response?.episodes || [];
            break;
        }

        if (newData?.length > 0) {
          setTotalEpisodes(newData);
          const updatedHcpLineIds = newData.map((item) => item.hcp_line_id);

         
          const prevId = isFirstItem
            ? updatedHcpLineIds[updatedHcpLineIds.length - 1]
            : allHcpData[currentIndex - 1];

          if (prevId) {
            changeRecord(prevId, newData);
            localStorage.setItem("last_hcp_line_id", prevId);
            triggerGetData2();
            return prevId;
          }
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    fetchDataAndUpdate();
    return prev;
  });
};


  const handleDocumentNext = () => {
  sessionStorage.setItem("trackHistory", JSON.stringify([]));
  sessionStorage.setItem("redoStack", JSON.stringify([]));
  handleEpisodeChange();
  setSkipAcceptApi(true);
  dispatch(setDocumentviewerPage(1));
  dispatch(resetEpisodeIdentifierTopassDocumentViewer());

  setCurrentEpisodeNumber((prev) => {
    const allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
    const currentIndex = allHcpData?.indexOf(prev);
    const isLastItem = currentIndex === allHcpData?.length - 1;

    let hasNextPage = false;
    if (currentScreen === "episodeList") {
      hasNextPage =
        newEpisodeListFilterObj.page <
        Math.ceil(
          episodesFilterList?.total_episodes /
            newEpisodeListFilterObj.page_size
        );
    } else if (currentScreen === "coderview") {
      hasNextPage =
        newEpisodeListFilterObj?.page_number <
        Math.ceil(codersData?.episode_meta_data?.meta?.total_count / 10);
    } else if (currentScreen === "auditorPage") {
      hasNextPage =
        newEpisodeListFilterObj?.page_number <
        Math.ceil(auditorViewData?.episode_meta_data?.meta?.total_count / 10);
    }

    // 🟢 prepare updated filter (for both cases)
    let updatedFilter = { ...newEpisodeListFilterObj };
    if (isLastItem && hasNextPage) {
      if (currentScreen === "episodeList") {
        updatedFilter.page += 1;
      } else {
        updatedFilter.page_number += 1;
      }
      localStorage.setItem("filters", JSON.stringify(updatedFilter));
    } else {
      // use same filter if not last
      updatedFilter = JSON.parse(localStorage.getItem("filters")) || updatedFilter;
    }

    // 🟢 single fetch function (for both cases)
    const fetchDataAndUpdate = async () => {
      try {
        let response;
        let newData = [];

        switch (currentScreen) {
          case "episodeList":
            response = await dispatch(getFilterEpisodeLists(updatedFilter)).unwrap();
            newData = response?.episode || [];
            break;

          case "coderview":
            response = await dispatch(fetchCodersData(updatedFilter)).unwrap();
            newData = response?.episodes || [];
            break;

          case "auditorPage":
            response = await dispatch(getAuditorViewData(updatedFilter)).unwrap();
            newData = response?.episodes || [];
            break;
        }

        if (newData?.length > 0) {
          setTotalEpisodes(newData);
          const updatedHcpLineIds = newData.map((item) => item.hcp_line_id);
          const nextId = isLastItem
            ? updatedHcpLineIds[0] // next page’s first item
            : allHcpData[currentIndex + 1]; // same page next item

          if (nextId) {
            changeRecord(nextId, newData);
            localStorage.setItem("last_hcp_line_id", nextId);
            triggerGetData2();
            return nextId;
          }
        }
      } catch (err) {
        console.error("❌ Fetch failed:", err);
      }
    };

    fetchDataAndUpdate();
    return prev;
  });
};


  const isCodeAssist =
    location.pathname.includes("Code-Assist") ||
    location.pathname.includes("Auditor-CodeAssist-Screen");
  const handleHopistalPasView = (mrnnumber, epidentifier) => {
    setShowTooltipHover(true);
    // console.log(mrnnumber, epidentifier, "fff");
    viewEmrDmrPas(mrnnumber, epidentifier)
      .then((res) => {
        // console.log(res, "hhehhe");

        setPasHyperLink(res.epic_url);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log(pasHyperLink, "checkhyp");
  const handleHyperLinkMouseLeave = () => {
    setShowTooltipHover(false);
  };
  useEffect(() => {
    dispatch(getHealthInsuranceManagerFilterOptions());
  }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: "60px",
      overflowY: "auto",
      width: "100%",
      fontSize: "12px",
      backgroundColor: "#c2e7ff",
      border: "none",
      outline: "none",
      fontWeight: "bold",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#344054",
      textAlign: "center",
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: state.isFocused ? "#f0f0f0" : "white",
      color: "black",
      cursor: "pointer",
      width: "100%",
    }),

    menu: (provided) => ({
      ...provided,
      width: "100%",
    }),

    menuList: (provided) => ({
      ...provided,
      width: "100%",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0",
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      display: "none",
    }),
  };

  // console.log(episodeList,'selectedEpisode');

  const handleStatusChange = (item) => {
    const statusValue = item?.value?.trim();
    const isCoderView = currentScreen === "coderview";
    const isAuditorPage = currentScreen === "auditorPage";

    const payload = {
      hcp_line_id: currentEpisode?.hcp_line_id,
      status: statusValue || currentEpisode?.status?.trim(),
      auditorPage: isAuditorPage ? true : false,
    };
    dispatch(changeStatus(payload))
      .unwrap()
      ?.then((res) => {
        // if(isAuditorPage){
        // dispatch(updateAuditorPage(true));
        // }else{
        // dispatch(updateAuditorPage(false));
        // }
        toast.success("Status updated successfully");
        if (isCoderView && statusValue === "Send to audit") {
          localStorage.setItem("episode-status-modal", "true");
          setOpenStatusUpdatedModal(true);
          setCurrentStatus(statusValue);
        } else if (isAuditorPage && statusValue === "Audited") {
          localStorage.setItem("episode-status-modal", "true");
          setOpenStatusUpdatedModal(true);
          setCurrentStatus(statusValue);
        } else {
          localStorage.setItem("episode-status-modal", "false");
          setOpenStatusUpdatedModal(false);
          setCurrentStatus(statusValue);
          window.location.reload();
        }
      })
      .catch((err) => {
        console.error("Status update error:", err);
        toast.error(err?.message || "Status update failed. Please try again.");
      });
  };

  // console.log(allOriginsAreU, allCodes, isButtonEnabled, "usercodes");

  const disablePrev = () => {
    if (currentScreen === "episodeList") {
      return (
        (newEpisodeListFilterObj.page === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "coderview") {
      return (
        (newEpisodeListFilterObj?.page_number === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "auditorPage") {
      return (
        (newEpisodeListFilterObj?.page_number === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    }
  };

  const disableNext = () => {
    if (currentScreen === "episodeList") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj.page ===
            (newEpisodeListFilterObj.page_size > 0
              ? Math.ceil(
                  episodesFilterList?.total_episodes /
                    newEpisodeListFilterObj.page_size
                )
              : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "coderview") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj?.page_number ===
            (10 > 0
              ? Math.ceil(codersData?.episode_meta_data?.meta?.total_count / 10)
              : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "auditorPage") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj?.page_number ===
            (10 > 0
              ? Math.ceil(
                  auditorViewData?.episode_meta_data?.meta?.total_count / 10
                )
              : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    }
  };

  const drawerContent = (
    <Box p={2} sx={{ backgroundColor: "c2e7ff", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: { md: "space-evenly" },
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ margin: "0px" }}>
          Episode Details
        </Typography>
        {!isCodeAssist && (
          <Pagination size="" className="episodestatus-pagination">
            <Pagination.Prev
              onClick={handleDocumentPrev}
              disabled={disablePrev()}
              className="prev-episode"
            />
            <Pagination.Next
              onClick={handleDocumentNext}
              disabled={disableNext()}
              className="next-episode"
            />
          </Pagination>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(200px, 100%), 1fr))",
          gap: 2,
        }}
      >
        {episodeDataWithLabel?.map((item, index) => (
          <Card>
            <CardActionArea
              sx={{
                height: "100%",
                "&[data-active]": {
                  backgroundColor: "action.selected",
                  "&:hover": {
                    backgroundColor: "action.selectedHover",
                  },
                },
              }}
            >
              <CardContent sx={{ height: "100%" }}>
                <Typography component="div" color="text.secondary">
                  {item?.label}
                </Typography>
                <Typography variant="body2" color="text.black">
                  {item?.value}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const TableRow = ({ label, value }) => (
    <tr>
      <td
        style={{
          padding: "8px",
          fontWeight: "bold",
          fontSize: "13px",
          color: "#555",
          width: "50%",
          textAlign: "center",
          // border: "1px solid #dddddd"
        }}
      >
        {label}
      </td>
      <td
        style={{
          padding: "8px",
          fontSize: "13px",
          color: "#333",
          textAlign: "center",
          fontWeight: "bold",
          // border: "1px solid #dddddd"
        }}
      >
        {value || "No value"}
      </td>
    </tr>
  );

  return (
    <Container fluid className="episode-container">
      <>
        {/* Row 1: Dynamic Episode Details */}
        {isLargeScreen && (
          <>
            <Grid
              container
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              spacing={1}
              sx={{
                display: "flex",
                width: "100%",
                flexWrap: "wrap",
                mt: { lg: 5, md: 2, sm: 2, xs: 1 },
                justifyContent: "space-between",
              }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Drawer
                  anchor="right"
                  variant={isLargeScreen ? "temporary" : "permanent"}
                  open={isLargeScreen ? mobileOpen : true}
                  onClose={handleDrawerToggle}
                  ModalProps={{ keepMounted: true }}
                  sx={{
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: {
                        lg: "30%",
                        md: "50%",
                        sm: "70%",
                        xs: "80%",
                      },
                    },
                  }}
                >
                  {drawerContent}
                </Drawer>
              </Grid>
            </Grid>
          </>
        )}
        {!isLargeScreen && (
          <Row className="d-flex  flex-wrap">
            {statusChangeMessage?.length > 0 && (
              <ToastContainer position="top-right" autoClose={3000} />
            )}
            <div
              className="d-flex flex-wrap align-items-center"
              style={{ gap: "5px" }}
            >
              <div className="d-flex align-items-center">
                <Typography
                  className="episode-header"
                  sx={{
                    padding: isCodeAssist ? "16px" : "0",
                    fontSize: {
                      lg: "16px",
                      md: "13px",
                      xs: "10px",
                    },
                  }}
                >
                  {" "}
                  {isCodeAssist ? "Code Assist" : "Episode Details"}
                </Typography>
                {!isCodeAssist && (
                  <Pagination size="" className="episodestatus-pagination">
                    <Pagination.Prev
                      onClick={handleDocumentPrev}
                      disabled={disablePrev()}
                      className="prev-episode"
                    />
                    <Pagination.Next
                      onClick={handleDocumentNext}
                      disabled={disableNext()}
                      className="next-episode"
                    />
                  </Pagination>
                )}
              </div>
              <Box
                className="d-flex flex-wrap"
                sx={{ gap: "5px", display: "flex" }}
              >
                {episodeDataWithDash?.map((item, index) => {
                  const labelKey = item.label?.trim();
                  const sliceLength = SLICE_CONFIG[labelKey];
                  const value = item.value || "-";
                  const shouldSlice = sliceLength && value.length > sliceLength;
                  return (
                    <Typography
                      component="span"
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: {
                          lg: "13px",
                          md: "12px",
                          xs: "11px",
                        },
                        color: "#6e7c87",
                      }}
                    >
                      {item.label}:
                      <Typography
                        className="info-value"
                        sx={{
                          marginLeft: "4px",
                          fontSize: {
                            lg: "13px",
                            md: "12px",
                            xs: "11px",
                          },
                        }}
                      >
                        {shouldSlice ? (
                          <Tooltip title={item?.value}>
                            <Typography
                              className="info-value"
                              sx={{
                                fontSize: {
                                  lg: "13px",
                                  md: "12px",
                                  xs: "11px",
                                },
                              }}
                            >
                              {item?.value?.slice(0, sliceLength)}...
                            </Typography>
                          </Tooltip>
                        ) : (
                          item?.value
                        )}
                      </Typography>
                    </Typography>
                  );
                })}
              </Box>
            </div>
          </Row>
        )}

        <Grid
          spacing={1}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            width: "100%",
            display: {
              xs: "block",
              md: "block",
              lg: "flex",
            },
            mt: { sm: 1, xs: 1 },
            justifyContent: "space-between",
            alignItems: {
              lg: "center",
              md: "center",
              xs: "center",
            },
            marginTop: {
              lg: "0",
              md: "15px",
              sm: "15px",
            },
            flexWrap: {
              lg: "wrap",
            },
          }}
        >
          <Grid
            sx={{
              display: {
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "block",
              },

              justifyContent: {
                lg: "start",
                md: "start",
                sm: "start",
                xs: "space-between",
              },
              height: {
                lg: "0px",
                // md: ",
                // lg: "0px",
                // lg: "0px",
              },
              alignItems: "center",
            }}
            className="status-wrapper"
          >
            {/* Episode details button for large screen */}

            <Grid
              item
              sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "auto",
                  lg: "auto",
                },
                display: {
                  lg: "flex",
                  md: "flex",
                  sm: "block",
                  xs: "flex",
                },
                justifyContent: {
                  lg: "space-between",
                  md: "space-between",
                  sm: "space-between",
                  xs: "space-between",
                },
                alignItems: "center",
              }}
              className="status-wrapper-div"
            >
              {isLargeScreen && !isSmallScreen && (
                <Grid
                  sx={{
                    mr: { lg: 1, md: 0, sm: 0, xs: 2 },
                    ml: { lg: 0, md: 0, sm: 0, xs: 0 },
                  }}
                >
                  <Button
                    variant="outline-secondary"
                    onClick={handleOpen}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    size="sm"
                    className="view-button"
                  >
                    {isCodeAssist ? (
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        Code Assist
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        Episode Details
                      </Typography>
                    )}
                    <ArrowDropDownIcon />
                  </Button>
                </Grid>
              )}
              {/* Episode details button for small screen */}

              {isSmallScreen && (
                <Grid
                  sx={{
                    mt: { sm: 0 },
                    mr: { sm: 1, sx: 1 },
                    mb: { sm: 1, xs: 0 },
                    ml: { sm: 0 },
                    p: {
                      sm: 2,
                    },
                    fontWeight: "600",
                  }}
                  className="view-epdetails-div"
                >
                  <Button
                    variant="outline-secondary"
                    onClick={handleOpen}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                    size="sm"
                    className="view-button"
                  >
                    {isCodeAssist ? (
                      <Typography sx={{ fontSize: "12px" }}>
                        Code Assist
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: "12px" }}>
                        Episode Details
                      </Typography>
                    )}
                    <ArrowDropDownIcon />
                  </Button>
                </Grid>
              )}
              <Grid
                sx={{
                  mt: { lg: 0, md: 0, sm: 1 },
                  mb: { lg: 0 },
                  ml: { lg: 0, md: 1, sm: 0 },
                  mr: { lg: 1, md: 1 },
                }}
                className="view-emr-div"
              >
                <div
                  style={{ display: "inline-block", position: "relative" }}
                  tabIndex={0}
                  className="view-smr-btn"
                >
                  <Tooltip
                    open={showTooltipHover}
                    onClose={() => setShowTooltipHover(false)}
                    title={
                      <div style={{ pointerEvents: "auto" }}>
                        <a
                          href={pasHyperLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "12px",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {pasHyperLink}
                        </a>
                      </div>
                    }
                    placement="top"
                    arrow
                    disableInteractive={false}
                  >
                    <Button
                      onBlur={() =>
                        setTimeout(() => setShowTooltipHover(false), 200)
                      }
                      className="view-button"
                      onClick={(e) => {
                        e.preventDefault();
                        handleHopistalPasView(
                          codingscreendata?.data?.meta?.episode_identifier,
                          codingscreendata?.data?.meta?.medical_record_number
                        );
                      }}
                    >
                      {isSmallScreen ? (
                        <Typography
                          sx={{ fontSize: "12px", textAlign: "center" }}
                        >
                          View EMR/SMR/DMR
                        </Typography>
                      ) : (
                        "View EMR/SMR/DMR"
                      )}
                      {/* View EMR/SMR/DMR */}
                    </Button>
                  </Tooltip>
                </div>
              </Grid>
            </Grid>

            <Grid
              item
              sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "auto",
                  lg: "auto",
                },
                display: {
                  lg: "contents",
                  md: "flex",
                  sm: "block",
                  xs: "flex",
                },
                alignItems: "center",
                justifyContent: {
                  lg: "end",
                  md: "end",
                  sm: "end",
                  xs: "space-between",
                },
                flexWrap: {
                  sm: "wrap",
                  xs: "wrap",
                },
              }}
              className="status-wrapper-div"
            >
              <Grid
                sx={{
                  mt: { lg: 0, sm: 0, xs: 1 },
                  mb: { lg: 0, md: 0, sm: 1 },
                  ml: { lg: 1, md: 0, sm: 0, xs: 0 },
                  mr: { lg: 1, md: 1 },
                }}
                className="my-actions-div"
              >
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    className="status-change-dropdown-btn"
                  >
                    <Tooltip title={"My Actions"}>
                      {isSmallScreen ? (
                        <Typography
                          sx={{ fontSize: "12px", textAlign: "center" }}
                        >
                          My Actions
                        </Typography>
                      ) : (
                        "My Actions"
                      )}
                      {/* My Actions */}
                    </Tooltip>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="my-actions-dropdown">
                    <Dropdown.Item
                      style={{ width: "100%" }}
                      onClick={() => {
                        setAuditStatusChangeModal(true);
                        dispatch(
                          getAuditResponse({
                            hcp_line_id: currentEpisode?.hcp_line_id
                              ? currentEpisode?.hcp_line_id
                              : last_hcp_line_id
                              ? last_hcp_line_id
                              : "",
                            episode_identifier:
                              currentEpisode?.episode_identifier
                                ? currentEpisode?.episode_identifier
                                : last_epi_identifier
                                ? last_epi_identifier
                                : "",
                          })
                        );
                      }}
                    >
                      <BiBarChartSquare
                        size={20}
                        color="#0d6efd"
                        className="me-2"
                      />
                      View audit log
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <FaEllipsisH color="#0D6EFD" size={20} className="me-2" />
                      Awaiting CDQ answer
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <BiMoney size={20} color="#0d6efd" className="me-2" />
                      Sending for billing
                    </Dropdown.Item>
                    <Divider sx={{ border: "1px solid black" }} />
                    {/* <Dropdown.Item> */}
                    {/* <Dropdown.Menu className="my-actions-dropdown"> */}
                    {(currentScreen === "auditorPage"
                      ? auditorOptions
                      : coderOptions
                    )?.map((item, index) => (
                      <Dropdown.Item
                        key={item?.value || index}
                        onClick={(e) => handleStatusChange(item)}
                      >
                        {item?.label}
                      </Dropdown.Item>
                    ))}
                    {/* </Dropdown.Menu> */}
                    {/* </Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>
              </Grid>
              <Grid
                sx={{
                  mt: { lg: 0, md: 0, sm: 0, xs: 1 },
                  mb: { lg: 0 },
                  ml: { lg: 1, md: 0, sm: 0, xs: 0 },
                  mr: { lg: 0 },
                }}
                className="my-actions-div"
              >
                <Box
                  sx={{
                    backgroundColor: "#c2e7ff",
                    color: "#344054",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "9px 12px",
                    textAlign: "center",
                  }}
                  className="status-value"
                >
                  {currentStatus
                    ? currentStatus
                    : currentEpisode?.status
                    ? currentEpisode?.status
                    : "Status"}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            sx={{
              display: {
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "block",
              },
              justifyContent: {
                lg: "space-between",
                md: "space-between",
                xs: "space-between",
              },
              mt: {
                xl: 0,
                lg: 0,
                md: 0,
                sm: 1,
                xs: 1,
              },
              alignItems: "center",
            }}
            className={location.pathname === "/coder" && "drg-opt-wrapper"}
          >
            <Grid
              sx={{
                ml: {
                  lg: 0,
                  xs: 0,
                },
                mt: { xs: 1 },
                mb: { xs: 1 },
                mr: { lg: 1 },
                display: "flex",
                justifyContent: "space-between",

                alignItems: {
                  lg: "center",
                  xs: "center",
                },
              }}
            >
              {(location.pathname === "/Code-Assist" ||
                location.pathname === "/Auditor-CodeAssist-Screen") && (
                <Box sx={{ mr: { lg: 2, md: 2, sm: 2 } }}>
                  <button
                    onClick={handleConfirmDrg}
                    className={`confirm-drg-code w-100 ${
                      drgConfirmedStatusUpdate || drgloading
                        ? "disabled"
                        : isButtonEnabled || allOriginsAreU
                        ? "enabled"
                        : "disabled"
                    }`}
                    disabled={
                      drgloading
                        ? true
                        : isDrgConfirmed || !(isButtonEnabled || allOriginsAreU)
                    }
                  >
                    {drgConfirmedStatusUpdate ? "Confirming..." : "Confirm DRG"}
                    <img
                      src={confirm_tick}
                      alt="confirm"
                      style={{ paddingLeft: "8px", width: "18px" }}
                    />
                  </button>
                </Box>
              )}
              <Box className="drg-header" sx={{display:"flex"}}>
                <span className="drg-options" style={{display:"flex",flexDirection:"column",alignItems:"start"}} onClick={handleDRGOptions}>
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "13px",
                        md: "13px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                      marginRight:"6px"
                    }}
                    className="drg-title"
                  >
                    DRG Options
                    <FaCog className="settings-icon" />
                  </Typography>
                  <Typography sx={{ fontSize: {
                        lg: "13px",
                        md: "13px",
                        xs: "12px",
                      },fontWeight:"600"
                      ,color:"#7a7a7aff"}}>
                    Drg Version:{selectedVersion?selectedVersion:" - "}
                  </Typography>
                </span>
      <Dropdown data-bs-theme="dark">
        <Dropdown.Toggle style={{fontSize:"14px",backgroundColor:"#c2e7ff",color:"black",border:"none",outline:"none"}} id="dropdown-button-dark-example1" variant="secondary" className="drgVersionsDropdown">
          Drg versions
        </Dropdown.Toggle>
        {drgData?.grouper_versions&&<Dropdown.Menu style={{fontSize:"14px",width:"100%","--bs-dropdown-min-width": "0px",}}>
          {
            drgData?.grouper_versions?.map((item,index)=>
              <Dropdown.Item as="button" onClick={() => handleSelect(item)}>{item}</Dropdown.Item>
            )
          }
        </Dropdown.Menu>}
      </Dropdown>




                {/* <Typography
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "13px",
                      xs: "12px",
                    },
                  }}
                  className="version-drg"
                >
                  Version 11
                </Typography> */}
              </Box>
            </Grid>
            <Grid>
              {drgloading ? (
                <Box
                  className="loading-div-wrapper"
                  sx={{
                    // padding: 12px 50px 12px 50px;
                    backgroundColor: "#0D3B66 !important",
                    borderRadius: "12px",
                    color: "white",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    mt: { sm: 1, xs: 1 },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "13px",
                        md: "13px",
                        xs: "12px",
                      },
                      marginBottom: "0px",
                    }}
                  >
                    Updating
                  </Typography>
                  <DotsLoader />
                </Box>
              ) : (
                <Dropdown
                  className="drg-dropdown"
                  // onClick={handleDrgInformation}
                >
                  {["960Z", "961Z", "963Z"].includes(selectedDrgData?.drg) ? (
                    // Show this for error DRG codes

                    <div className="drg-error-block">
                      <div className="d-flex gap-2">
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "13px",
                              md: "13px",
                              xs: "12px",
                            },
                            color: "red",
                          }}
                        >
                          {selectedDrgData?.drg}
                        </Typography>
                        {drgLabels[selectedDrgData?.drg] && (
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                              fontWeight: "bold",
                            }}
                          >
                            {drgLabels[selectedDrgData?.drg]}
                          </Typography>
                        )}
                      </div>
                    </div>
                  ) : (
                    // Show this for normal DRG codes
                    <Dropdown.Toggle variant="dark" className="drg-button">
                      <Box className="drg-info">
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "13px",
                              md: "13px",
                              xs: "12px",
                            },
                          }}
                          className="drg-key"
                        >
                          DRG
                        </Typography>
                        {drgloading ? (
                          <BiLoader />
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                            }}
                            className="drg-value"
                          >
                            {selectedDrgData?.drg ? selectedDrgData?.drg : "-"}
                          </Typography>
                        )}
                      </Box>
                      <Box className="drg-info">
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "13px",
                              md: "13px",
                              xs: "12px",
                            },
                          }}
                          className="drg-key"
                        >
                          Weight
                        </Typography>
                        {drgloading ? (
                          <BiLoader />
                        ) : selectedDrgData?.weight === "can't determine" ? (
                          <span className="drg-value">-</span>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                            }}
                            className="drg-value"
                          >
                           {selectedDrgData?.weight ? selectedDrgData?.weight?.toFixed(4) : "-"}
                            {/* {weightValue ? weightValue.toFixed(4) : "-"} */}
                          </Typography>
                        )}
                      </Box>
                      <Box className="drg-info">
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "13px",
                              md: "13px",
                              xs: "12px",
                            },
                          }}
                          className="drg-key"
                        >
                          Reimbursement
                        </Typography>
                        {drgloading ? (
                          <BiLoader />
                        ) : weightValue === "can't determine" ? (
                          <span className="drg-value">-</span>
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                            }}
                            className="drg-value"
                          >
                            {selectedDrgData?.weight === "can't determine" || !selectedDrgData?.weight
                              ? "-"
                              : `$${Math.round(
                                  selectedDrgData?.weight * 6465
                                ).toLocaleString()}`}
                          </Typography>
                        )}
                      </Box>
                    </Dropdown.Toggle>
                  )}

                  <Dropdown.Menu className="drg-menu">
                    {allDrgInfoLoading ? (
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "13px",
                            md: "13px",
                            xs: "12px",
                          },
                        }}
                      >
                        Loading...
                      </Typography>
                    ) : (
                      <div>
                        <div className="drg-item">
                          <div className="drg-label">
                            {selectedDrgData?.drg}
                          </div>
                          <img src={drg1Icon} alt="" className="drg-icon" />
                          <div className="drg-detail">
                            {/* <FaNotesMedical className="drg-icon" /> */}
                            {selectedDrgData?.additional_information?.description}
                            <Box
                              sx={{
                                fontFamily: {
                                  sm: "11px",
                                },
                              }}
                            >
                              {" "}
                              Inlier Wgt {selectedDrgData?.additional_information?.inlier} Lower Bound{" "}
                              {selectedDrgData?.additional_information?.lower_bound} Upper Bound{" "}
                              {selectedDrgData?.additional_information?.upper_bound} Same Day{" "}
                              {selectedDrgData?.additional_information?.same_day} ALOS{" "}
                              {selectedDrgData?.additional_information?.alos}
                            </Box>
                          </div>
                        </div>

                        <div className="drg-item">
                          <div className="drg-label">
                            {selectedDrgData?.additional_information?.eccs}
                          </div>
                          <img src={drg4Icon} alt="" className="drg-icon" />
                          <div className="drg-detail">
                            {/* <FaRegStar className="drg-icon" /> */}
                            Episode Clinical Complexity Score
                            <p>A&nbsp;&nbsp; ECCS &gt;= 2.5</p>
                            <p>B&nbsp;&nbsp; ECCS &lt; 2.5</p>
                          </div>
                        </div>

                        <div className="drg-item">
                          <div className="drg-label">
                            {selectedDrgData?.additional_information?.mdc_code}
                          </div>
                          <img src={drg3Icon} alt="" className="drg-icon" />
                          <div className="drg-detail">
                            {/* <FaClock className="drg-icon" /> */}
                            {selectedDrgData?.additional_information?.mdc_description}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="drg-item">
                  <div className="drg-label">Total DCL</div>
                  <div className="drg-detail">
               
                    <img src={drg2Icon} alt="" className="drg-icon" />
                    32,344
                  </div>
                </div> */}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Modal
          open={auditStatusChangeModal}
          onClose={() => setAuditStatusChangeModal(false)}
          aria-labelledby="episode-audit-log-title"
          aria-describedby="episode-audit-log-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 600 },
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              outline: "none",
            }}
          >
            {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                id="episode-audit-log-title"
                variant="h6"
                fontWeight="bold"
                fontSize="16px"
              >
                Episode Audit Log
              </Typography>
              <IconButton onClick={() => setAuditStatusChangeModal(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Table Content */}
            <Box
              component="table"
              width="100%"
              sx={{
                borderCollapse: "collapse",
                mt: 1,
              }}
            >
              <tbody>
                {[
                  { label: "Time", value: auditStatusStateData?.TIME },
                  {
                    label: "Additional Diagnoses",
                    value: auditStatusStateData?.additional_diagnoses1,
                  },
                  { label: "DRG Code", value: auditStatusStateData?.drg_code },
                ].map(({ label, value }) => (
                  <TableRow key={label} label={label} value={value} />
                ))}
              </tbody>

              <tbody>
                {[
                  "principal_diagnosis_code",
                  "procedure_codes1",
                  "procedure_codes2",
                  "procedure_codes3",
                  "procedure_codes4",
                  "procedure_codes5",
                  "procedure_codes6",
                  "procedure_codes7",
                ].map((field, index) => (
                  <TableRow
                    key={field}
                    label={
                      index === 0
                        ? "Principal Diagnosis Code"
                        : `Procedure Code ${index}`
                    }
                    value={auditStatusStateData?.[field]}
                  />
                ))}
              </tbody>
            </Box>
          </Box>
        </Modal>
        {checkModalStatus && (
          <div className="episodeStatus-him-assign-modal-overlay-fade">
            <div className="episodeStatus-him-assign-modal-container">
              <div className="episodeStatus-him-assign-header">
                <p className="episodeStatus-him-assign-header-text">
                  {episodeList?.selectedEpisode?.status === "Audited" ? (
                    <span>
                      Auditing is completed for this episode. Please navigate to
                      your workspace to begin coding the next episode.
                    </span>
                  ) : (
                    <span>
                      Coding is completed for this episode. Please navigate to
                      your workspace to begin coding the next episode.
                    </span>
                  )}
                </p>
                <div className="episode-status-redirect-container">
                  <button
                    className="episode-status-redirect-btn"
                    onClick={() => {
                      if (currentScreen === "coderview") {
                        navigate("/Coder-Workspace");
                      } else if (currentScreen === "auditorPage") {
                        navigate("/Auditor-Workspace");
                      }
                      localStorage.setItem("episode-status-modal", false);
                    }}
                  >
                    Redirect
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </Container>
  );
};

export default EpisodeStatus;